<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="management" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-info" outlined @click="addNewDonationSession()">ADD DONATION SESSION</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>DONATION SESSIONS</span>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div class="donation-session-item" v-for="(item, index) in donation_sessions" :key="index"
            @click="selectDonationSession(item)" :class="{
              active:
                selected_donation_session &&
                selected_donation_session.id == item.id,
            }">
            <div v-if="item.image" class="donation-session-item-cover-image-panel">
              <img :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                item.image
                " />
            </div>
            <div class="donation-session-item-top-panel">
              <div class="donation-session-item-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="donation-session-item-option">
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>

                  <b-dropdown-item v-clipboard:copy="getDonationPublicLink(item.id)"
                    v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Get
                    Link</b-dropdown-item>

                  <b-dropdown-item @click="updateDonationSession(item)" aria-role="listitem">Update</b-dropdown-item>
                  <b-dropdown-item @click="deleteDonationSession(item)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="donation-session-item-body-panel">
              {{ item.description }}
            </div>
            <div class="donation-session-item-bottom-panel">
              <div class="donation-session-item-bottom-left">
                <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rigth-panel active_session" v-if="selected_donation_session">
        <div class="rigth-panel-header">
          <div class="rigth-panel-header-title">
            <span>{{ selected_donation_session.title }}</span>
            <div class="rigth-panel-header-actions">
              <p @click="resetSession()">Close</p>
            </div>
          </div>
        </div>
        <div class="rigth-panel-body">
          <div class="rigth-panel-body-header">
            <div class="rigth-panel-body-header-left-options">
              <button :class="{ active: switch_tab == 'overview' }" @click="switchTab('overview')">OVERVIEW</button>
              <button :class="{ active: switch_tab == 'donated' }" @click="switchTab('donated')">DONATED USERS</button>
            </div>
          </div>

          <div v-if="switch_tab == 'overview'" class="overview-panel">
            <div class="overview-section">
              <span class="overview-section-title">Donation Details</span>
              <div class="overview-details-grid">
                <div class="overview-card">
                  <span class="overview-label">Status</span>
                  <div class="overview-value">
                    <b-tag v-if="selected_donation_session.status == 'public'" type="is-success">Public</b-tag>
                    <b-tag v-if="selected_donation_session.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                  </div>
                </div>

                <div class="overview-card">
                  <span class="overview-label">Donated Users</span>
                  <div class="overview-value">
                    <span class="overview-stat">{{ donatedUsersCount }}</span>
                  </div>
                </div>

                <div class="overview-card">
                  <span class="overview-label">Total Donated</span>
                  <div class="overview-value">
                    <span class="overview-stat">{{ totalDonatedAmountLabel }}</span>
                  </div>
                </div>

                <div class="overview-card">
                  <span class="overview-label">USSD Code</span>
                  <div class="overview-copy-row">
                    <span class="overview-copy-text">{{ donationUssdCode }}</span>
                    <b-button size="is-small" type="is-primary" outlined
                      v-clipboard:copy="donationUssdCode"
                      v-clipboard:success="onCopyUssd"
                      v-clipboard:error="onCopyError">
                      Copy
                    </b-button>
                  </div>
                </div>

                <div class="overview-card overview-card-full">
                  <span class="overview-label">Public Link</span>
                  <div class="overview-copy-row">
                    <span class="overview-copy-text">{{ donationPublicLink }}</span>
                    <b-button size="is-small" type="is-primary" outlined
                      v-clipboard:copy="donationPublicLink"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onCopyError">
                      Copy
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="overview-section">
              <span class="overview-section-title">QR Codes</span>
              <div class="overview-qr-grid">
                <div class="overview-card overview-qr-card">
                  <span class="overview-label">USSD QR Code</span>
                  <div class="overview-qr-container">
                    <widgetQrCodePreview :value="donationUssdTelLink" />
                  </div>
                  <b-button size="is-small" type="is-primary" outlined icon-left="download"
                    @click="downloadQrCode(donationUssdTelLink, 'ussd')">
                    Download
                  </b-button>
                </div>
                <div class="overview-card overview-qr-card">
                  <span class="overview-label">Donation Link QR Code</span>
                  <div class="overview-qr-container">
                    <widgetQrCodePreview :value="donationPublicLink" />
                  </div>
                  <b-button size="is-small" type="is-primary" outlined icon-left="download"
                    @click="downloadQrCode(donationPublicLink, 'donation-link')">
                    Download
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="switch_tab == 'donated'" class="table-widget">
            <div v-if="!loading_donated_user && donatedUsers.length > 0" class="donated-summary">
              <span>{{ donatedUsersCount }} donated</span>
              <span>{{ totalDonatedAmountLabel }} total</span>
            </div>

            <div v-if="!loading_donated_user && donatedUsers.length > 0">
              <table>
                <tr>
                  <th>Name</th>
                  <th>Amount</th>
                  <th></th>
                </tr>
                <tr v-for="donation in donatedUsers" :key="donation.id">
                  <td>{{ donation.names }}</td>
                  <td>{{ formatDonationAmount(donation) }}</td>
                  <td>
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="deleteDonatedUser(donation)" aria-role="listitem">
                        Delete</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="loading_donated_user">
              <table>
                <tr>
                  <th>Name</th>
                  <th>Amount</th>
                  <th></th>
                </tr>
                <tr v-for="(item, index) in 15" :key="index">
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                </tr>
              </table>
            </div>

            <div v-if="!loading_donated_user && donatedUsers.length == 0">
              <widgetNotfound title="No Donated Users Found"
                subtitle="There are no donated users for this session yet.">
              </widgetNotfound>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="rigth-panel">
        <widgetNotfound title="No Donation Selected"
          subtitle="Select a donation session to view details and donated users."></widgetNotfound>
      </div>
    </div>

    <addNewDonationSessionModal v-if="show_add_vote_session_modal && channel_details" :channel="channel_details"
      :value="selected_donation_session" @saved="onDonationSessionSaved()" @close="show_add_vote_session_modal = false">
    </addNewDonationSessionModal>
  </div>
</template>

<script>
import addNewDonationSessionModal from "./modals/addNewDonationSessionModal.vue";
import TabsWidget from "./components/TabsWidget.vue";
const QRCode = require("qrcode");

export default {
  components: {
    addNewDonationSessionModal,
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    switch_tab: "overview",
    channel_details: null,
    loading_channel_details: false,
    show_add_vote_session_modal: false,
    selected_donation_session: null,
    loading_donation_session: false,
    donation_sessions: [],
    loading_donated_user: false,
    donatedUsers: [],
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
    vm.loadPartnerWebsiteUrl();
  },
  methods: {
    loadPartnerWebsiteUrl() {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_GET_WEBSITE_THEME")
        .then((response) => {
          if (response.data.return && response.data.return.webSiteBaseUrl) {
            vm.$store.commit("SET_WEB_SITE_BASE_URL", response.data.return.webSiteBaseUrl);
          }
        })
        .catch(() => { });
    },
    getDonationPublicLink(sessionId) {
      return `${this.$getPartnerSiteBaseUrl()}donation/${sessionId}`;
    },
    selectDonationSession(item) {
      let vm = this;
      vm.selected_donation_session = item;
      vm.switch_tab = "overview";
      vm.loadDonatedUsers(item.id);
    },
    loadDonatedUsers(sessionId) {
      let vm = this;
      vm.loading_donated_user = true;
      vm.$store
        .dispatch("DONATION_GET_ALL_DONETED_USERS", {
          session_id: sessionId,
        })
        .then((response) => {
          vm.loading_donated_user = false;
          vm.donatedUsers = response.data.return || [];
        })
        .catch(() => {
          vm.loading_donated_user = false;
          vm.donatedUsers = [];
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: "Something went wrong, Contact your administrator",
          });
        });
    },
    resetSession() {
      let vm = this;
      vm.selected_donation_session = null;
      vm.donatedUsers = [];
      vm.switch_tab = "overview";
    },
    switchTab(type) {
      let vm = this;
      if (type === "management") {
        vm.$emit("tab", type);
        return;
      }

      vm.switch_tab = type;
      if (type === "donated" && vm.selected_donation_session && vm.donatedUsers.length === 0 && !vm.loading_donated_user) {
        vm.loadDonatedUsers(vm.selected_donation_session.id);
      }
    },
    deleteDonatedUser(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Delete Donated User",
        message: `Are you sure you want to delete the donation from <b>${item.names}</b>? This will also remove its related transaction record. This action cannot be undone.`,
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("DONATION_DELETE_DONATED_USER", { id: item.id })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Success",
                text: response.data.message || "Donated user deleted successfully",
              });
              vm.loadDonatedUsers(vm.selected_donation_session.id);
            })
            .catch(() => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    deleteDonationSession(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Donation Session",
        message:
          "Are you sure you want to <b>delete</b> this donation session? This action cannot be undone.",
        confirmText: "Delete Session",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("DONATE_DELETE_DONATION_SESSION", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_donation_session = null;
              vm.getMyDonationSessions();

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    updateDonationSession(item) {
      let vm = this;
      vm.selected_donation_session = item;
      vm.show_add_vote_session_modal = true;
    },
    addNewDonationSession() {
      let vm = this;
      vm.selected_donation_session = null;
      vm.show_add_vote_session_modal = true;
    },
    onDonationSessionSaved() {
      let vm = this;
      vm.show_add_vote_session_modal = false;
      vm.getMyDonationSessions();
    },
    getMyDonationSessions() {
      let vm = this;
      vm.loading_donation_session = true;
      vm.$store
        .dispatch("DONATE_GET_ALL_DONATION_SESSION")
        .then((response) => {
          vm.loading_donation_session = false;
          vm.donation_sessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_donation_session = false;
        });
    },
    getMyChannelDetails() {
      let vm = this;
      vm.loading_channel_details = true;
      vm.loading_donation_session = true;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.loading_channel_details = false;
          vm.channel_details = response.data.return;
          vm.getMyDonationSessions();
        })
        .catch(({ response }) => {
          vm.loading_channel_details = false;
        });
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyUssd() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "USSD code copied to clipboard",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    formatDonationAmount(donation) {
      const currency = donation.currency || "RWF";
      const amount = Number(donation.amount || 0);
      return `${currency} ${this.$formatMoney(amount, 0, ".", ",")}`;
    },
    downloadQrCode(value, type) {
      let vm = this;
      const session = vm.selected_donation_session;
      const slug = (session && session.title) ? session.title.replace(/\s+/g, "-").toLowerCase() : ("donation-" + (session && session.id));
      const filename = slug + "-" + type + "-qr.png";

      QRCode.toDataURL(value, function (err, url) {
        if (err) {
          vm.$buefy.toast.open({
            message: "Failed to download QR code",
            type: "is-danger",
          });
          return;
        }

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        vm.$buefy.toast.open({
          message: "QR code downloaded",
          type: "is-success",
        });
      });
    },
  },
  computed: {
    donationUssdCode() {
      if (!this.selected_donation_session) return "";
      return `*550*2*3*${this.selected_donation_session.id}#`;
    },
    donationUssdTelLink() {
      return `tel:${this.donationUssdCode}`;
    },
    donationPublicLink() {
      if (!this.selected_donation_session) return "";
      return this.getDonationPublicLink(this.selected_donation_session.id);
    },
    donatedUsersCount() {
      if (this.loading_donated_user) return "...";
      return this.donatedUsers.length;
    },
    totalDonatedAmount() {
      return this.donatedUsers.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    },
    donatedUsersCurrency() {
      const first = this.donatedUsers[0];
      return (first && first.currency) || "RWF";
    },
    totalDonatedAmountLabel() {
      if (this.loading_donated_user) return "...";
      if (!this.donatedUsers.length) return `${this.donatedUsersCurrency} 0`;
      return this.formatDonationAmount({
        currency: this.donatedUsersCurrency,
        amount: this.totalDonatedAmount,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;
      margin-right: 20px;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: 35% 65%;

    @media (max-width: 860px) {
      grid-template-columns: 40% 60%;
    }

    @media (max-width: 638px) {
      grid-template-columns: 100%;
    }

    .left-panel {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;
        position: sticky;
        top: 0;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .donation-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          background: transparent;
          transition: .5s;

          &:hover {
            background: #dbdbdb;
          }

          &.active {
            background: #dbdbdb;
          }

          .donation-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .donation-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .donation-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .donation-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .donation-session-item-body-panel {
            padding: 0px 10px;
          }

          .donation-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .donation-session-item-bottom-left {
              display: flex;
              flex-direction: column;
            }
          }
        }
      }
    }

    .left-panel,
    .rigth-panel {
      min-width: 0;
    }

    .rigth-panel {
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      @media (max-width: 638px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.active_session {
        @media (max-width: 638px) {
          right: 0;
        }
      }

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;

        .rigth-panel-header-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          position: sticky;
          top: 0;
          background: white;
          width: 100%;

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
            min-width: 0;
          }

          .rigth-panel-header-actions {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
          }

          p {
            display: none;
            margin-left: 0;
            color: red;
            font-weight: 700;
            cursor: pointer;
            white-space: nowrap;

            @media (max-width: 638px) {
              display: flex;
            }
          }
        }
      }

      .rigth-panel-body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 60px);
        min-width: 0;
        max-width: 100%;

        .overview-panel {
          flex: 1;
          min-height: 0;
          min-width: 0;
          width: 100%;
          max-width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 20px 24px;
          background: #f5f6f8;
          display: flex;
          flex-direction: column;
          gap: 20px;

          @media (max-width: 640px) {
            padding: 16px;
          }
        }

        .overview-section {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .overview-section-title {
          display: block;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.04em;
          color: #666;
          text-transform: uppercase;
        }

        .overview-details-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
          }
        }

        .overview-card {
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          min-height: 88px;
          justify-content: center;
        }

        .overview-card-full {
          grid-column: 1 / -1;
        }

        .overview-label {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.04em;
          color: #888;
          text-transform: uppercase;
        }

        .overview-value {
          display: flex;
          align-items: center;
          min-height: 32px;
        }

        .overview-stat {
          font-size: 24px;
          font-weight: 700;
          color: #333;
        }

        .overview-copy-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          min-height: 32px;
        }

        .overview-copy-text {
          flex: 1;
          min-width: 0;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          word-break: break-all;
          line-height: 1.4;
        }

        .overview-qr-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
          }
        }

        .overview-qr-card {
          align-items: center;
          text-align: center;
          padding-bottom: 20px;
          gap: 12px;
        }

        .overview-qr-container {
          width: 148px;
          height: 148px;
          background: #fff;
          border: 1px solid #ececec;
          border-radius: 8px;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .rigth-panel-body-header {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ececec;
          height: 60px;
          flex-shrink: 0;
          overflow-y: auto;

          .rigth-panel-body-header-left-options {
            display: flex;
            align-items: center;

            button {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              padding: 0px 50px;
              border: none;
              border-bottom: 3px solid transparent;
              background: transparent;
              transition: .5s;
              white-space: nowrap;

              &:hover {
                border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
              }

              &.active {
                border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
                color: var(--wecodefy-secondary-color, #9fc953);
              }
            }
          }
        }

        .table-widget {
          flex: 1;
          min-height: 0;
          overflow-y: auto;

          .donated-summary {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 12px 16px;
            margin-bottom: 12px;
            background: #f5f6f8;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            color: #333;
          }

          table {
            width: 100%;

            tr {
              th {
                white-space: nowrap;
              }

              td {
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
</style>
